import React from "react";
import propTypes from 'prop-types';
import { AtmosphereImage } from './AtmosphereImage';

export function EditiorialParallaxImages (props) {
    const { block, images } = props;
    const imageLeft = images[0];
    const imageRight = images[1];
    const imageBottom = images[2];
    
    return (
        <div className={`${block}__images`}>
            { imageLeft && <span
                className={`${block}__images--image-left`}
                data-parallax-target={true}
                data-parallax-speed={2.5}
                data-parallax-constraint={230}
                aria-hidden
            >
                <AtmosphereImage {...{
                    base: imageLeft?.base,
                    animationDelay: 0.1,
                    id: imageLeft?.id,
                    showExpandIcon: true
                }}/>
            </span> }
            { imageRight && <span
                className={`${block}__images--image-right`}
                data-parallax-target={true}
                data-parallax-speed={2.5}
                data-parallax-constraint={430}
                aria-hidden
            >
                <AtmosphereImage {...{
                    base: imageRight?.base,
                    animationDelay: 0.1,
                    id: imageRight?.id,
                    showExpandIcon: true
                }}/>
            </span>}
            { imageBottom && <span
                className={`${block}__images--image-bottom`}
                data-parallax-target={true}
                data-parallax-speed={2.5}
                data-parallax-constraint={430}
                aria-hidden
            >
                <AtmosphereImage {...{
                    base: imageBottom?.base,
                    animationDelay: 0.1,
                    id: imageBottom?.id,
                    showExpandIcon: true
                }}/>
            </span>}
        </div> 
    )
}

EditiorialParallaxImages.propTypes = {
    applyLbxTheme: propTypes.bool,
    block: propTypes.string,
    title: propTypes.string, 
    subtitle: propTypes.string, 
};